import { createContext } from "react";

export type ContainsDialogsContextData = {
	registerDialog?(): () => void;
};

export const ContainsDialogsContext = createContext<ContainsDialogsContextData>({
	registerDialog: undefined
});